import script from "./SelectBoxWithIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBoxWithIcon.vue?vue&type=script&setup=true&lang=js"

import "./SelectBoxWithIcon.vue?vue&type=style&index=0&id=422fe01a&lang=scss&scoped=true"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-422fe01a"]])

export default __exports__